import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MaterialCodigoBarra } from "../shared/material-codigo-barra.model";
import { Material } from "../../material/shared/material.model";
import { MaterialCodigoBarraService } from "../shared/material-codigo-barra.service";
import { MaterialService } from "../../material/shared/material.service";
import { materialCodigoBarraTitle } from "../../material/shared/data.service";
import { UtilService } from "../../../../shared/services/util.service";
import { newRoute, editRoute } from "../../../../shared/services/data.service";

declare var swal: any;

@Component({
    template: require('./material-codigo-barra-register.component.html')
})

export class MaterialCodigoBarraRegisterComponent implements OnInit {
    materialCodigoBarraTitle: any = materialCodigoBarraTitle;
    actionTitle: string;
    itemObject: any = new MaterialCodigoBarra();

    private materialObject: any = new Material();

    constructor(
        private _service: MaterialCodigoBarraService,
        private _materialService: MaterialService,
        private _utilService: UtilService,
        private _route: ActivatedRoute
    ){}

    ngOnInit() {
        let id = +this._route.snapshot.params['id'];
        this.itemObject = this._service.getStorage();
        this.materialObject = this.itemObject.material;

        if (id) {
            this.actionTitle = editRoute;
            this.itemObject.id = id;
        } else {
            this.actionTitle = newRoute;
        }
    }

    onclickSend(arg: any) {
        if (this.actionTitle === editRoute) {
            this.onEdit(arg);
        } else {
            this.onSave(arg);
        }
    }

    onclickGoToMaterialDetail() {
        this._materialService.goToDetail(this.materialObject.id);
    }

    onclickCancel() {
        this.onclickGoToMaterialDetail();
    }

    onSave(arg: any) {
        this.onDone(arg);
    }

    onEdit(arg: any) {
        this.onDone(arg);
    }

    private onDone = (function(Response: any) {
        if (!Response.error) {
            if (this.actionTitle === editRoute) {
              this._utilService.swalMessageEditSuccess();
            } else {
              this._utilService.swalMessageAddSuccess();
            }
            this.onclickGoToMaterialDetail();
        } else {
          this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-codigo-barra/material-codigo-barra-register/material-codigo-barra-register.component.ts
 **/